import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Testimonials from './pages/Testimonials';
import Proprietorship from './pages/Proprietorship';
import PublicLtdCompany from './pages/PublicLtdCompany';
import PartnershipFirm from './pages/PartnershipFirm';
import PrivateLtdCompany from './pages/PrivateLtdCompany';
import OPCRegistration from './pages/OPCRegistration';
import LLPRegistration from './pages/LLPRegistration';
import Section8Company from './pages/Section8Company';
import ProducerCompany from './pages/ProducerCompany';
import IndianSubsidiaryRegistration from './pages/IndianSubsidiaryRegistration';
import TrustRegistration from './pages/TrustRegistration';
import StartupRegistration from './pages/StartupRegistration';
import FSSAILicense from './pages/FSSAILicense';
import IECCodeRegistration from './pages/IECCodeRegistration';
import UdyamRegistration from './pages/UdyamRegistration';
import ShopActRegistration from './pages/ShopActRegistration';
import LEICodeRegistration from './pages/LEICodeRegistration';
import TrademarkRegistration from './pages/TrademarkRegistration';
import TradeLicenseRegistration from './pages/TradeLicenseRegistration';
import ICEGATERegistration from './pages/ICEGATERegistration';
import PFESICRegistration from './pages/PFESICRegistration';
import ADCodeRegistration from './pages/ADCodeRegistration';
import APEDARegistration from './pages/APEDARegistration';
import GSTRegistration from './pages/GSTRegistration';
import BarcodeRegistration from './pages/BarcodeRegistration';
import PTReturnFiling from './pages/PTReturnFiling';
import PFEsiReturnsFiling from './pages/PFEsiReturnsFiling';
import GSTReturnFiling from './pages/GSTReturnFiling';
import IncomeTaxReturnFiling from './pages/IncomeTaxReturnFiling';
import TDSReturnFiling from './pages/TDSReturnFiling';
import ROCAnnualFiling from './pages/ROCAnnualFiling';
import VirtualCFOServices from './pages/VirtualCFOServices';
import BookkeepingServices from './pages/BookkeepingServices';
import BusinessConsultationServices from './pages/BusinessConsultationServices';
import DebtSyndicationServices from './pages/DebtSyndicationServices';
import InternalAuditServices from './pages/InternalAuditServices';
import ForensicServices from './pages/ForensicServices';
import IPOServices from './pages/IPOServices';
import WhatsAppButton from "./components/WhatsAppButton";
function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
           <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/proprietorship-regn" element={<Proprietorship />} />
            <Route path="/public-ltd-company" element={<PublicLtdCompany />} />
            <Route path="/partnership-firm" element={<PartnershipFirm />} />
            <Route path="/private-ltd-company" element={<PrivateLtdCompany />} />
            <Route path="/opc-registration" element={<OPCRegistration />} />
            <Route path="/llp-registration" element={<LLPRegistration />} />
            <Route path="/section-8-company" element={<Section8Company />} />
            <Route path="/producer-company" element={<ProducerCompany />} />
            <Route path="/indian-subsidiary" element={<IndianSubsidiaryRegistration />} />
            <Route path="/trust-registration" element={<TrustRegistration />} />
            <Route path="/opc-registration" element={<OPCRegistration />} />
            <Route path="/startup-registration" element={<StartupRegistration />}/>
            <Route path="/fssai-license-regn" element={<FSSAILicense />} />
            <Route path="/iec-code-registration" element={<IECCodeRegistration />} />
            <Route path="/udyam-registration" element={<UdyamRegistration />} />
            <Route path="/shop-act-registration" element={<ShopActRegistration />} />
            <Route path="/lei-code-registration" element={<LEICodeRegistration />} />
            <Route path="/trademark-registration" element={<TrademarkRegistration />} />
            <Route path="/trade-license-registration" element={<TradeLicenseRegistration />} />
            <Route path="/icegate-registration" element={<ICEGATERegistration />} />
            <Route path="/pf-and-esic-registration" element={<PFESICRegistration />} />
            <Route path="/ad-code-registration" element={<ADCodeRegistration />} />
            <Route path="/apeda-registration" element={<APEDARegistration />} />
            <Route path="/gst-registration" element={<GSTRegistration />} />
            <Route path="/barcode-registration" element={<BarcodeRegistration />} />
            <Route path="/pt-return-filing" element={<PTReturnFiling />} />
            <Route path="/pf-and-esi-returns-filing" element={<PFEsiReturnsFiling />} />
            <Route path="/gst-return-filing" element={<GSTReturnFiling />} />
            <Route path="/income-tax-filing" element={<IncomeTaxReturnFiling />} />
            <Route path="/tds-return-filing" element={<TDSReturnFiling />} />
            <Route path="/roc-annual-filing" element={<ROCAnnualFiling />} />
            <Route path="/virtual-cfo-services" element={<VirtualCFOServices />} />
            <Route path="/bookkeeping-service" element={<BookkeepingServices />} />
            <Route path="/business-consultation" element={<BusinessConsultationServices />} />
            <Route path="/debt-syndication" element={<DebtSyndicationServices />} />
            <Route path="/internal-audit-services" element={<InternalAuditServices />} />
            <Route path="/forensic-services" element={<ForensicServices />} />
            <Route path="/ipo-services" element={<IPOServices />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;